import type { AnalyzeResult, ApiError, Portfolio, PortfolioInput } from '@prm/shared';

const BASE = '/api';

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
  });

  const text = await res.text();
  let body: unknown = null;
  if (text !== '') {
    try {
      body = JSON.parse(text);
    } catch {
      throw new Error(`${res.status}: unexpected non-JSON response`);
    }
  }

  if (!res.ok) {
    const err = body as ApiError | null;
    throw new Error(err?.detail ? `${err.error}: ${err.detail}` : (err?.error ?? `request failed (${res.status})`));
  }

  return body as T;
}

export const api = {
  health: () => request<{ ok: boolean; provider: string; time: string }>('/health'),

  savePortfolio: (input: PortfolioInput) =>
    request<Portfolio>('/portfolio', { method: 'POST', body: JSON.stringify(input) }),

  getPortfolio: (id: string) => request<Portfolio>(`/portfolio/${id}`),

  listPortfolios: () =>
    request<{ portfolios: Array<{ id: string; name: string; updatedAt: string }> }>('/portfolios'),

  analyze: (id: string) => request<AnalyzeResult>(`/analyze/${id}`),
};
